import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";
import { StateStorage } from "zustand/middleware";

/**
 * Cross-platform storage adapter for Zustand persist middleware.
 * Uses Capacitor Preferences for native apps (iOS/Android) and localStorage for web/PWA.
 */
export const createCrossPlatformStorage = (): StateStorage => {
  if (Capacitor.isNativePlatform()) {
    // Native: Use Capacitor Preferences
    return {
      getItem: async (name: string): Promise<string | null> => {
        const { value } = await Preferences.get({ key: name });
        return value;
      },
      setItem: async (name: string, value: string): Promise<void> => {
        await Preferences.set({ key: name, value });
      },
      removeItem: async (name: string): Promise<void> => {
        await Preferences.remove({ key: name });
      },
    };
  } else {
    // Web/PWA: Use localStorage
    return {
      getItem: (name: string): string | null => {
        return localStorage.getItem(name);
      },
      setItem: (name: string, value: string): void => {
        localStorage.setItem(name, value);
      },
      removeItem: (name: string): void => {
        localStorage.removeItem(name);
      },
    };
  }
};
